import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import SuccessPage from 'pages/excursions/success-page'

import { RESULT_PAYMENT } from 'shared/api/check-payment'

import { ExcursionError } from './components/excursions-error'
import { ExcursionsPending } from './components/excursions-pending'

type Props = {
  status: RESULT_PAYMENT
}

export const ExcursionSuccess = ({ status }: Props) => {
  const navigate = useNavigate()
  const onClick = () => {
    navigate(RoutingPaths.myOrders.path())
  }

  if (status === RESULT_PAYMENT.CANCELLED) {
    return <ExcursionError onClick={onClick} />
  }

  if (
    status === RESULT_PAYMENT.IN_PROGRESS ||
    status === RESULT_PAYMENT.CREATED ||
    status === RESULT_PAYMENT.LOADING
  ) {
    return <ExcursionsPending onClick={onClick} />
  }
  return <SuccessPage />
}
